import { Suspense, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { ErrorBoundary } from '@xing-com/crate-core-error-boundary';

import * as S from './master-directory-data-boundary.styled';

const LoadingError: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
  return (
    <S.ErrorContainer>
      <S.ErrorMessage>
        <FormattedMessage id="CRATE_MASTER_DIRECTORY_LOADING_ERROR" />
      </S.ErrorMessage>
      <Button size="small" variant="secondary" onClick={onRetry}>
        <FormattedMessage id="CRATE_MASTER_DIRECTORY_LOADING_ERROR_RETRY" />
      </Button>
    </S.ErrorContainer>
  );
};

type MasterDirectoryDataBoundaryProps = {
  children: React.ReactNode | ((queryKey: number) => React.ReactNode);
};

export const MasterDirectoryDataBoundary: React.FC<
  MasterDirectoryDataBoundaryProps
> = ({ children }) => {
  const [retryCount, setRetryCount] = useState(0);
  const content =
    typeof children === 'function' ? children(retryCount) : children;

  return (
    <ErrorBoundary
      key={retryCount}
      onError={() => (
        <LoadingError onRetry={() => setRetryCount((count) => count + 1)} />
      )}
    >
      <Suspense fallback={null}>{content}</Suspense>
    </ErrorBoundary>
  );
};
